import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import React from 'react';
export var TopicNavSection = function (_a) {
    var href = _a.href, onHeadingClick = _a.onHeadingClick, heading = _a.heading, children = _a.children;
    return (React.createElement(Box, { display: "flex", flex: "0 0 auto", alignItems: "center", paddingX: "xl", className: "rb-topic-nav__section" },
        React.createElement(Button, { type: "button", href: href, border: true, onClick: onHeadingClick }, heading),
        React.createElement(Box, { display: "flex", alignItems: "center", className: "rb-topic-nav__section-children" }, children)));
};
